import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './less/reset.less'
// import Vconsole from 'vconsole'
// import wx from 'weixin-js-sdk'
// new Vconsole()
import Vant from 'vant'
import 'vant/lib/index.css'
import './less/common.less'
// import './less/vant-override.less'

const app = createApp(App)

/**
 * 日期格式换算 YYYY-MM-DD hh:mm:ss => YYYY/MM/DD
 */
app.config.globalProperties.$filters = {
  dateFormat(time) {
    if (time) {
      return time.split(' ')[0].replace(/-/g, '/')
    }
  }
}

app.use(Vant)
app.use(router)
app.mount('#app')
